(function() {
'use strict';

angular
    .module('TR')
    .controller('SearchUnit', SearchUnit);

function SearchUnit(
    pageStrand,
    $timeout,
    $scope,
    resourceService,
    searchUnitService,
    $route,
    $location,
    dateUtil,
    $window,
    basketService,
    broker,
    geo,
    analytics,
    currentDestination,
    occupancyService,
    holidayDeals,
    searchQueryString,
    destinationService
) {
    const cm = this;

    cm.showTabs = !TRPCONFIG.Domain.CompactMobileTabs || _.includes(['hotels', 'holidays'], $route.current.area);

    const searchMsgs = ['SEARCHINGFLIGHTS', 'SEARCHINGHOTELS', 'SEARCHINGTRANSFERS', 'MARHABASEARCHING', 'SEARCHINGFLIGHTS', 'SEARCHINGINSURANCE'];

    let minimumDate = dateUtil.todayPlus(1, 0, true);

    //none of this needs be done if we're already in the availability path
    //because we will not be displaying the search unit
    if (cm.hotel && cm.hotel.Rooms != null) {
        return;
    }
    cm.supportsGeo = geo.supported();

    cm.autoCompleterSelect = autoCompleterSelect;
    cm.getEndDate = getEndDate;
    cm.getStartDate = getStartDate;
    cm.setStartDate = setStartDate;
    cm.setEndDate = setEndDate;
    cm.showStartDate = showStartDate;
    cm.showEndDate = showEndDate;
    cm.flexibleDates = searchUnitService.flexibleDates === undefined ? true : searchUnitService.flexibleDates;
    cm.searchType = $route.current.area;
    cm.onewayonly = false;
    cm.productToggle = productToggle;
    cm.nearby = nearby;
    cm.search = search;

    let mode = searchUnitService.flight;
    let flow = basketService.holidayBooking;
    switch ($route.current.area) {
        case 'hotels':
            minimumDate = dateUtil.todayPlus(TRPCONFIG.Domain.HotelSearchOffsetDate, 0, true);
            if ((new Date()).getUTCHours() >= TRPCONFIG.Domain.TimeCutoffForSameDayHotelSearch) {
                 //if current time exceeds same day search cutoff, set min date to next day for hotel searches
                 minimumDate = dateUtil.todayPlus(1, 0, true);
            }
            mode = searchUnitService.hotel;
            flow = basketService.hotelBooking;
            break;
        case 'transfers':
            if (searchUnitService.getDirection() === 3) {
                minimumDate = null;
            }
            mode = searchUnitService.transfer;
            flow = basketService.transferBooking;
            break;
        case 'marhaba':
            minimumDate = dateUtil.todayPlus(2, 0, true);
            mode = searchUnitService.marhaba;
            flow = basketService.marhabaBooking;
            break;
        case 'flights':
            mode = searchUnitService.flight;
            flow = basketService.flightBooking;
            break;
        case 'insurance':
            mode = searchUnitService.insurance;
            flow = basketService.insuranceBooking;
            break;
    }
    const minimumDatePlusOne = dateUtil.addDays(minimumDate, 1, true) || dateUtil.todayPlus(1, 0, true);

    cm.durations = holidayDeals.DURATIONS.map(d => ({
        name: `${d} ${resourceService.get('NIGHTS')}`,
        value: d
    }));
    cm.duration = searchUnitService.duration(mode);
    cm.updateDuration = () => {
        searchUnitService.duration(mode, cm.duration);
    };
    cm.focusOnDuration = () => {
        $('.duration select[name="duration"]').focus();
    };

    // Cabin
    cm.cabin = searchUnitService.getCabin();
    cm.cabinOptions = searchUnitService.getCabinOptions();
    cm.updateCabin = () => {
        searchUnitService.setCabin(cm.cabin);
    };

    broker.subscribe('SearchUnit', 'savedSearchRestored', function() {
        cm.summary = searchUnitService.getSummary(mode);
    });

    cm.deselectAllAirlines = () => {
        delete searchUnitService.airlines;
        $location.search('airlines', null);
        cm.summary = searchUnitService.getSummary(mode);
    };

    $scope.$on('$destroy', () => {
        broker.unsubscribe('SearchUnit');
    });

    let waiting = false;

    cm.startDate = searchUnitService.startDate(mode);
    cm.endDate = searchUnitService.endDate(mode);
    cm.dealsFlexibility = searchUnitService.dealsFlexibility;
    cm.outboundDates = searchUnitService.getOutboundDates(mode);
    if (cm.startDate) {
        cm.startPlusOne = dateUtil.addDays(cm.startDate, 1, true);
    }
    cm.minDates = {
        minimumDate,
        startPlusOne: cm.startPlusOne || minimumDatePlusOne
    };

    cm.flexibleDatesDisabled = function() {
        return TRPCONFIG.Domain2.FlexibleDatesFlowsDisabled.indexOf(searchUnitService.capitalize(cm.searchType)) !== -1;
    };

    $scope.$watch('cm.startDate', val => {
        if (val) {
            cm.showStartCalendar = false;
            cm.setStartDate(val);
        }
    });
    $scope.$watch('cm.dealsFlexibility', val => searchUnitService.dealsFlexibility = val);

    loadNearestAirports();

    let clearParams = () => {
        //cleardown query params - as otherwise params will override values search unit values when not necessary
        $location.replace()
            .search('startDate', null)
            .search('endDate', null)
            .search('depAir', null)
            .search('occ', null)
            .search('autoSearch', null)
            .search('cabin', null);
    };

    searchQueryString.getQueryStringValues().then(queryString => {
        searchUnitService.airlines = queryString.airlines;

        if (queryString.startDate != null) {
            cm.setStartDate(queryString.startDate, false);
        }
        if (queryString.endDate != null) {
            cm.setEndDate(queryString.endDate, false);
        }
        if (cm.startDate) {
            cm.startPlusOne = dateUtil.addDays(cm.startDate, 1, true);
        }
        if (queryString.airports) {
            if (queryString.airports.length === 1) {
                searchUnitService.setDepartureAirports(queryString.airports[0]);
            } else {
                searchUnitService.setDepartureAirports(queryString.airports);
            }
        }
        if (queryString.occupancy != null) {
            occupancyService.setOccupancy(queryString.occupancy);
        }
        if (queryString.autoSearch) {
            //set the current destination to run the search against
            currentDestination.getCurrentDestination().then(dest => {
                if (dest != null) {
                    cm.autoCompleterSelect(dest, false);
                } else if (queryString.destination) {
                    destinationService.getDetails(queryString.destination[0]).then(destination => {
                        if (destination != null) {
                            searchUnitService.setDestination(destination);
                            searchUnitService.setDestinationAirport(destination);
                        }
                    });
                    searchUnitService.setDestinationAirport(queryString.destination[0]);
                }
                $timeout(() => {
                    cm.search();
                    clearParams();
                }, 1000);
            });
        } else {
            clearParams();
        }

        cm.summary = searchUnitService.getSummary(mode);
    });

    $timeout(function() {
        if ($route.current.area === 'transfers') {
            const destinationAirports = searchUnitService.getDestinationAirports();
            if (destinationAirports && destinationAirports.length > 1) {
                searchUnitService.setDestinationAirport();
            }
        }

        currentDestination.getCurrentDestination().then(function(dest) {
            if (dest && !dest.HolidayEnabled && flow === basketService.holidayBooking) {
                $scope.$emit('flash:error', String.format(resourceService.get('NOTHOLIDAYENABLED'), dest.Title));
            }
            cm.summary = searchUnitService.getSummary(mode);
            cm.flightType = searchUnitService.getFlightType().Label;
            if (TRPCONFIG.Domain.DurationEnable) {
                initDurationInput();
            }
        });
    }, 0);

    function autoCompleterSelect(item, back = true) {
        if (!waiting) {
            waiting = true;
            return searchUnitService.setDestination(item, false, true).then(function(d) {
                waiting = false;
                d.changed = true;
                if (back) {
                    //this has to go in a setTimeout so that it does not take place in the context of a call to
                    //$apply. If it does it causes infinite digest loops in some phones
                    setTimeout(function() {
                        $window.history.back();
                    }, 0);
                }
            }); //yuck yak
        }
    }

    function getStartDate() {
        return searchUnitService.startDate(mode);
    }

    function getEndDate() {
        return searchUnitService.endDate(mode);
    }

    function setEndUsingDuration(durationLength) {
        let duration = searchUnitService.duration(mode, durationLength);
        duration = duration && duration.value || TRPCONFIG.Domain.SearchUnitDurationDefault;

        const endDate = dateUtil.addDays(getStartDate(), duration, true);
        setEndDate(endDate, null);
    }

    function setStartDate(date, back) {
        if (date) {
            cm.minDates.startPlusOne = dateUtil.addDays(date, 1, true);
        }
        searchUnitService.startDate(mode, date);
        cm.summary = searchUnitService.getSummary(mode);
        cm.showStartCalendar = false;

        if (TRPCONFIG.Domain.DurationEnable) {
            setEndUsingDuration();
        }

        if (back) {
            setTimeout(function() {
                $window.history.back();
            }, 0);
        }
    }

    function setEndDate(date, back) {
        searchUnitService.endDate(mode, date);
        cm.summary = searchUnitService.getSummary(mode);
        cm.showEndCalendar = false;
        if (back) {
            setTimeout(function() {
                $window.history.back();
            }, 0);
        }
    }

    function initDurationInput() {
        cm.options = searchUnitService.getDurationOptions();

        $scope.$watch('cm.duration', function() {
            if (cm.duration) {
                setEndUsingDuration(cm.duration || TRPCONFIG.Domain.SearchUnitDurationDefault);
            } else if (searchUnitService.duration(mode)) {
                cm.duration = cm.options[searchUnitService.duration(mode).index];
            } else {
                cm.duration = cm.options[0];
            }
        });
    }

    function showStartDate() {
        return $route.current.area !== 'transfers' || searchUnitService.requiresStartDate();
    }

    function showEndDate() {
        return $route.current.area !== 'transfers' || searchUnitService.requiresEndDate();
    }

    function productToggle(r) {
        if ($route.current.landing) {
            let currentStrand = pageStrand.fromRoute();
            const strand = pageStrand.opposite(currentStrand);
            $location.url(pageStrand.adjustUrl($location.url(), strand));
            $route.reload();
        } else {
            $location.path(r);
        }
    }

    function nearby(e) {
        e.stopPropagation();
        cm.gettingLocation = true;
        $scope.$emit('flash:error');
        geo.getSearchArea().then(function(sa) {
            analytics.trackEvent({ label: 'search nearby' });
            searchUnitService.setSearchArea(sa);
            cm.summary = searchUnitService.getSummary(mode);
            cm.gettingLocation = false;
        }, function() {
            cm.gettingLocation = false;
            $scope.$emit('flash:error', resourceService.get('POSITIONUNAVAILABLE'));
        });
    }

    function search() {

        $scope.$emit('block', {
            title: resourceService.get(searchMsgs[flow]),
            subtitle: resourceService.get('THISMAYTAKE'),
            loadingScreenStyle: 'default-searchUnitCtrl'
        });

        searchUnitService.flexibleDates = TRPCONFIG.Domain.FlexibleDatesEnabled ? cm.flexibleDates : true;
        searchUnitService.onewayonly = TRPCONFIG.Domain.OneWayFlightsEnabled ? cm.onewayonly : false;

        const isAirlinesPrefilter = !_.some(searchUnitService.airlines, a => a.IsPostfilter);
        const params = {
            flexibleDates: searchUnitService.flexibleDates,
            oneWayOnly: searchUnitService.onewayonly,
            prefilterAirlines: isAirlinesPrefilter ? _.map(searchUnitService.airlines, a => a.Code) : [],
            postfilterAirlines: !isAirlinesPrefilter ? _.map(searchUnitService.airlines, a => a.Title) : []
        };
        basketService.startWorkflow(flow, params).then(null, function(errors) {
            broker.publish('unblock');
            $scope.$emit('unblock');
            $scope.$emit('flash:error', errors);
        });
    }

    function loadNearestAirports() {
        const departureAirports = searchUnitService.getDepartureAirports();
        if (!departureAirports || !departureAirports.length) {
            geo.getNearestAirports().then(airports => {
                // Check a second time to not overwrite a departure airport
                // that could have been selected before this promise resolved.
                const departureAirports = searchUnitService.getDepartureAirports();
                if (!departureAirports || !departureAirports.length) {
                    searchUnitService.setMultipleDepartureAirports(airports);
                    cm.summary = searchUnitService.getSummary(mode);
                }
            });
        }
    }
}
})();
